// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ContainerTwoToneSvg from "@fishx/icons-svg/es/asn/ContainerTwoTone";
import FishxIcon from '../components/FishxIcon';

var ContainerTwoTone = function ContainerTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ContainerTwoToneSvg
  }));
};

ContainerTwoTone.displayName = 'ContainerTwoTone';
export default React.forwardRef(ContainerTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ContainerTwoTone.js
// module id = 2320
// module chunks = 0